let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dHgfr")).then(() => parcelRequire('bGKPg'));